import { ready } from 'core-utilities';
import React from 'react';
import { render } from 'react-dom';
import Roblox from 'Roblox';
import App from './App';
import { rootElementId } from './app.config';
import '../../../css/crossDeviceLoginDisplayCodeModal/crossDeviceLoginDisplayCodeModal.scss';
import { openModal } from './services/crossDeviceLoginDisplayCodeService';

Roblox.CrossDeviceLoginDisplayCodeService = {
  openModal
};

ready(() => {
  if (document.getElementById(rootElementId)) {
    render(<App />, document.getElementById(rootElementId));
  }
});
